(function($) {
    if ($('.featured-section').length > 0) {
        console.log('Featured Section loaded');
    }
})(jQuery);
